var _defs, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustratieGeneralIdea({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 184.94815 172.74847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-14 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #66c3ec;\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-4 {\n        fill: #bbd773;\n      }\n\n      .cls-5 {\n        fill: #454545;\n      }\n\n      .cls-6 {\n        fill: #757575;\n      }\n\n      .cls-7 {\n        fill: #e0c1a4;\n      }\n\n      .cls-8 {\n        fill: #987f51;\n      }\n\n      .cls-9 {\n        fill: #6bad7c;\n      }\n\n      .cls-10 {\n        fill: #dde3e9;\n      }\n\n      .cls-11 {\n        fill: #79c48e;\n      }\n\n      .cls-12 {\n        isolation: isolate;\n        opacity: 0.15;\n      }\n\n      .cls-13 {\n        clip-path: url(#clip-path-2);\n      }\n\n      .cls-14 {\n        stroke: #d94c3c;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n        stroke-dasharray: 6 8;\n      }\n\n      .cls-15 {\n        fill: #eb5241;\n      }\n\n      .cls-16 {\n        fill: #555;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.41714,106.4887a49.5403,49.5403,0,0,0,93.25317-33.47851l-.00018-.00049a49.5403,49.5403,0,1,0-93.253,33.479Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.67014,73.0097a49.5403,49.5403,0,1,0-29.887,63.366"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M77.73815,146.6076a2.0001,2.0001,0,0,1-1.882-1.325L36.61715,35.98773A2.00015,2.00015,0,0,1,37.824,33.42962h.00018a2,2,0,0,1,2.558,1.207h0l39.239,109.29493a2.00016,2.00016,0,0,1-1.20682,2.5581h-.00018A2.00029,2.00029,0,0,1,77.73815,146.6076Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    className: "cls-2",
    d: "M11.41714,106.4887a49.5403,49.5403,0,0,0,93.25317-33.47851l-.00018-.00049a49.5403,49.5403,0,1,0-93.253,33.479Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1529",
    "data-name": "Rectangle 1529",
    className: "cls-4",
    d: "M27.84128,66.26563,5.9,74.14677a5.73,5.73,0,0,1-7.32978-3.45532h0a5.73,5.73,0,0,1,3.456-7.32948l21.94129-7.88114a5.73,5.73,0,0,1,7.32978,3.45532h0A5.73,5.73,0,0,1,27.84128,66.26563Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    className: "cls-4",
    d: "M-30.08884,112.81073a13.6,13.6,0,0,1,8.674-16.346l46.972-16.864a13.6141,13.6141,0,0,1,17.217,7.332,13.365,13.365,0,0,1-7.22436,17.46582q-.29993.1245-.60562.23413l-11.224,4.03a1.663,1.663,0,0,0-1,2.127h0a1.66307,1.66307,0,0,0,2.127,1l4.5-1.616a6.99,6.99,0,0,1,8.94089,4.2168l.00012.00024h0a6.991,6.991,0,0,1-4.217,8.9419l-41.658,14.956a6.99191,6.99191,0,0,1-8.942-4.218h0a6.991,6.991,0,0,1,4.218-8.94092l-1.138-3.168a13.353,13.353,0,0,1-16.598-9.0061Q-30.06822,112.88324-30.08884,112.81073Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1530",
    "data-name": "Rectangle 1530",
    className: "cls-4",
    x: 55.83025,
    y: 115.08346,
    width: 26.49236,
    height: 10.78752,
    rx: 5.39326,
    transform: "translate(-36.66033 30.44361) rotate(-19.7579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    className: "cls-4",
    d: "M62.39815,73.14764l13.164-4.72607a2.622,2.622,0,0,0,1.733-3.02588,2.523,2.523,0,0,0-3.3-1.771l-5.581,2a6.14207,6.14207,0,0,1-7.85591-3.70581l-.00009-.00024h0a6.141,6.141,0,0,1,3.70352-7.85547l.00148-.00049,36.092-12.958a2.5239,2.5239,0,0,1,3.227,1.522l2.446,6.814a2.524,2.524,0,0,1-1.522,3.227l-5.611,2.01392a2.621,2.621,0,0,0-1.732,3.02587,2.52288,2.52288,0,0,0,3.3,1.771l5.746-2.063A2.52186,2.52186,0,0,1,109.435,58.937l.00017.00048,2.446,6.814a2.515,2.515,0,0,1-.331,2.33008l1.973,5.49389,4.148-1.489a5.551,5.551,0,0,1,6.916,2.686,5.39985,5.39985,0,0,1-2.57216,7.19043q-.235.11132-.47984.19946l-36.443,13.083a5.5509,5.5509,0,0,1-6.915-2.686,5.39985,5.39985,0,0,1,2.57216-7.19043q.235-.11133.47984-.19946l11.621-4.17212a2.7,2.7,0,0,0,1.628-3.45093h0a2.7,2.7,0,0,0-3.451-1.62793l-24.236,8.7a6.313,6.313,0,0,1-8.032-3.44189,6.14189,6.14189,0,0,1,3.46709-7.96411Q62.31175,73.17865,62.39815,73.14764Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M58.09815,147.76556a58.01422,58.01422,0,0,1-19.657-112.616l1.351,3.7649a54.01274,54.01274,0,1,0,36.506,101.67016l1.352,3.76489A57.74748,57.74748,0,0,1,58.09815,147.76556Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M39.21914,165.53656c8.1,0,16.5-12.447,16.5-19.06592h5.137c0,6.61889,8.4,19.06592,16.5,19.06592s8.1,7.21191,8.1,7.21191h-54.338S31.11816,165.53656,39.21914,165.53656Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Leg",
    className: "cls-5",
    d: "M156.88915,83.50872l-14.4,47.167,2.727,34.60009h8.011l1.124-33.0581,24.914-48.708Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Leg-2",
    className: "cls-6",
    d: "M156.84115,83.50872c7.37,26.05005,8.837,44.554,8.837,44.554s1.926,7.7,10.234,37.21191h8.3c-1-5.51611-1.8-.71606-2.432-5.5a174.30777,174.30777,0,0,1-.195-44.95507,226.60085,226.60085,0,0,0,1.708-31.30591Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Shoe",
    d: "M180.79815,172.74774v-.83008l-5.4.82788h-15.779V171.0866s9.991-2.7,16.194-7.05908h8.72l.415,8.72Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Shoe-2",
    d: "M150.19814,172.74774v-.83008l-5.4.82788h-15.779V171.0866s9.991-2.7,16.194-7.05908h8.72l.415,8.72Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Head-2",
    className: "cls-7",
    d: "M156.84315,39.49359l1.688-11.93994c-2.689,1.62011-5.331,2.3999-6.571,2.083-3.11-.8-3.4-12.176-.989-16.66088s14.775-6.44,15.4,2.446a11.24717,11.24717,0,0,1-2.992,8.082l3.431,15.991Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    className: "cls-8",
    d: "M158.03315,16.40374a8.08667,8.08667,0,0,0-2.766-2.831c-4.381.06909-4.894-.71607-4.894-3.363a15.42947,15.42947,0,0,1,6-1.6001,7.23713,7.23713,0,0,1,4.744.3501,6.15619,6.15619,0,0,1,4.463,4.1001c2.718,4.69311.655,9.57788-2.127,11.24609-.74-.877-1.386-1.727-1.963-2.541a2.49135,2.49135,0,0,0-2.04-4.25586C159.12015,17.61175,158.48815,17.10052,158.03315,16.40374Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Coat_Back",
    "data-name": "Coat Back",
    className: "cls-9",
    d: "M137.59815,51.71258c-7.546.97608-10.541,1.84912-24.264-5.188l3.906-6.10009c4.912,1.218,8.541.74389,12.8.81909a30.7556,30.7556,0,0,0,10.993-1.83106c4.835-1.74389,10.754-3.94311,18.148-6.687l4.5,5.186C158.88316,49.71453,143.01714,51.01776,137.59815,51.71258Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Shirt",
    className: "cls-10",
    d: "M165.07615,29.94769l-9.164,1.437c0,17.37793-3.517,36.47388-5.939,48.68189-.21,1.0581-.484,3.154.968,3.154l25.3-1.57691C174.75015,61.5036,172.65615,42.1347,165.07615,29.94769Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Coat_Front",
    "data-name": "Coat Front",
    className: "cls-11",
    d: "M179.94315,64.92059a104.38087,104.38087,0,0,1,3.89,21.081h-28.6c-5.536-13.991,6.8-56.05688,6.8-56.05688h3.631C173.71415,34.62054,178.15515,57.93963,179.94315,64.92059Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    className: "cls-12",
    d: "M104.66814,73.00653a49.518,49.518,0,0,0-45.5-32.79A49.5409,49.5409,0,0,1,70.01586,136.0202l-.01773.00635a49.35993,49.35993,0,0,1-17.87,2.90991A49.53839,49.53839,0,0,0,104.6686,73.00775Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    className: "cls-14",
    d: "M119.37015,77.48065c4.244-13.44092-7.471-29.12207-26.165-35.0249s-37.29.21-41.533,13.6521,5.532,28.46411,24.226,34.366"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    className: "cls-15",
    d: "M90.17615,91.64764l-6.205.72412a.321.321,0,0,1-.329-.45288l4.1-8.844a.32107.32107,0,0,1,.42618-.1565l.00083.00049,4.83,2.24a.32.32,0,0,1,.15669.42456l-.00069.00147-2.726,5.8789A.322.322,0,0,1,90.17615,91.64764Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    className: "cls-15",
    d: "M136.85215,10.53265a2.4,2.4,0,0,0-1.237-3.02905L119.92216.22454a2.39984,2.39984,0,0,0-3.112,1.01294L85.76415,57.1054l28.5,13.21607Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    className: "cls-16",
    d: "M112.83115,74.10662l1.43-3.78491-28.5-13.21606-1.965,3.53589a3.06194,3.06194,0,0,0-.08,2.82592c1.628,3.35889,5.2,12.27393,2.012,20.48609a1.208,1.208,0,0,0,.62,1.531l5.868,2.721a1.20686,1.20686,0,0,0,1.569-.51611c4.21-7.738,13.322-10.77,16.938-11.7A3.06475,3.06475,0,0,0,112.83115,74.10662Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    className: "cls-16",
    d: "M130.98016,53.23358l12.194-33.314a1.209,1.209,0,0,0-.627-1.51391l-6.9-3.19995-1.886-.875-19.735-9.1521a1.389,1.389,0,0,0-1.8.585l-7.777,14a1.387,1.387,0,0,0,.53737,1.88647c.03.0166.06052.03223.09163.04663l23.739,11.009a1.38692,1.38692,0,0,0,1.84226-.67359q.02163-.0465.03974-.09448l4.3-11.384,2.258,1.04712a1.2119,1.2119,0,0,1,.628,1.51489l-10.5,28.679a1.21007,1.21007,0,0,0,.627,1.51392l1.318.61108a1.21,1.21,0,0,0,1.6082-.58471C130.9538,53.30169,130.96777,53.268,130.98016,53.23358Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    className: "cls-7",
    d: "M130.92315,66.94256l-20.125-5.91406a45.51809,45.51809,0,0,1-12.378-.42993c-.909-.376-2.192-1.33692.722-2.145s5.94-1.79,5.981-2.8999-2.094-1.64209-1.774-3.23291q.316-1.59229,9.838,3.835l18.1.82495Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    className: "cls-11",
    d: "M162.24215,35.99676c-7.849,26.293-39.386,18.78-47.148,19.6001l-.664,7.26709s34.939,20.34912,57.279-15.854"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustratieGeneralIdea);
export default __webpack_public_path__ + "static/media/illustratie_general_idea.71f5e9a7a4bf1b627a6bb4ea04210353.svg";
export { ForwardRef as ReactComponent };